import { EQUIPMENT, IMG } from "../data/content";
import { Reveal, SectionTag, PageHeader, QuoteCTA } from "../components/Shared";

const PIPELINE = [
  { step: "01", title: "Intake & Engineering", body: "Specs reviewed, materials selected, structural files prepared." },
  { step: "02", title: "Print & Cut", body: "Calibrated grand-format printing with camera-registered cutting." },
  { step: "03", title: "Fabricate & Assemble", body: "CNC, metal work, LED wiring, and hand finishing." },
  { step: "04", title: "QC & Install", body: "Every piece inspected, packed, and installed by certified crews." },
];

export default function Infrastructure() {
  return (
    <div data-testid="infrastructure-page">
      <PageHeader
        tag="Infrastructure"
        title={<>The Floor Where<br />It All Happens.</>}
        subtitle="Our Woodbridge production facility houses printing, cutting, fabrication, LED assembly, and quality control — a complete manufacturing pipeline under one roof."
      />

      <section className="pb-20" data-testid="infrastructure-facility-section">
        <div className="msg-container grid grid-cols-1 lg:grid-cols-3 gap-6">
          <Reveal className="lg:col-span-2">
            <div className="img-frame aspect-[16/9] relative h-full">
              <img src={IMG.machinery} alt="Grand format printing machinery" loading="lazy" />
              <span className="corner-notch" />
              <span className="absolute bottom-4 left-4 z-10 font-mono text-[10px] tracking-widest uppercase text-white">Production Floor — Woodbridge, ON</span>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="img-frame aspect-[16/9] lg:aspect-auto lg:h-full relative">
              <img src={IMG.press} alt="Industrial printing press" loading="lazy" />
              <span className="absolute bottom-4 left-4 z-10 font-mono text-[10px] tracking-widest uppercase text-white">Grand-Format Print Line</span>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-20" style={{ background: "var(--bg-2)" }} data-testid="infrastructure-equipment-section">
        <div className="msg-container">
          <Reveal>
            <SectionTag>Equipment Lineup</SectionTag>
            <h2 className="font-display font-black uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl mt-5">Production Capabilities</h2>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
            {EQUIPMENT.map((e, i) => (
              <Reveal key={e.name} delay={i * 0.06}>
                <div className="msg-card p-8 h-full relative overflow-hidden" data-testid={`equipment-card-${i}`}>
                  <span className="absolute top-0 left-0 w-1 h-full" style={{ background: e.color }} />
                  <span className="font-mono text-xs" style={{ color: e.color }}>{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="font-display font-bold uppercase text-lg mt-3">{e.name}</h3>
                  <p className="text-sm mt-3 leading-relaxed" style={{ color: "var(--text-2)" }}>{e.spec}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24" data-testid="infrastructure-pipeline-section">
        <div className="msg-container">
          <Reveal>
            <SectionTag>Manufacturing Pipeline</SectionTag>
            <h2 className="font-display font-black uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl mt-5">From File to Facade</h2>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l mt-12" style={{ borderColor: "var(--line)" }}>
            {PIPELINE.map((p, i) => (
              <Reveal key={p.step} delay={i * 0.08}>
                <div className="p-8 border-r border-b h-full" style={{ borderColor: "var(--line)" }}>
                  <span className="font-display font-black text-4xl" style={{ color: ["var(--brand-orange)", "var(--brand-magenta)", "var(--brand-cyan)", "var(--brand-lime)"][i] }}>{p.step}</span>
                  <h3 className="font-display font-bold uppercase text-base mt-4">{p.title}</h3>
                  <p className="text-sm mt-3 leading-relaxed" style={{ color: "var(--text-2)" }}>{p.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <QuoteCTA />
    </div>
  );
}
